import { render, staticRenderFns } from "./LikedProfiles.vue?vue&type=template&id=014598b3&"
import script from "./LikedProfiles.vue?vue&type=script&lang=js&"
export * from "./LikedProfiles.vue?vue&type=script&lang=js&"
import style0 from "./LikedProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports